import { z } from "zod/v4";

export const campaignStatusSchema = z.enum(["active", "inactive", "completed"]);
export type CampaignStatus = z.infer<typeof campaignStatusSchema>;

export const campaignChannelSchema = z.enum(["message", "call"]);
export type CampaignChannel = z.infer<typeof campaignChannelSchema>;

export type Campaign = {
  id: string;
  name: string;
  status: CampaignStatus;
  default_channel: CampaignChannel;
  started_at: string | null;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
  integration_name: string | null;
};

export type CampaignListItem = Campaign & {
  total_leads: number;
  last_lead_at: string | null;
  engaged_count: number;
  won_count: number;
  conversion_rate: number;
};

export type CampaignStats = {
  total_leads: number;
  new_count: number;
  engaged_count: number;
  won_count: number;
  lost_count: number;
  unqualified_count: number;
  last_lead_at: string | null;
};
